import React, { useState, useEffect, useContext } from 'react';
import './App.css';
import { ChakraProvider } from '@chakra-ui/react'
import Home from './components/orders/Home'
import { LinkContext } from './LinkContext';
import axios from 'axios';
import Loading from './components/Loading';

function App({query}: {query: string}) {
  const context = useContext(LinkContext);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${context}/${query}`);
        setData(response.data);
        setIsLoading(false);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, [])

  return (
    <ChakraProvider>
      {isLoading ? 
        <Loading/> :
        <Home data={data}/>
      }
    </ChakraProvider>
  );
}

export default App;
